import clsx from 'clsx';
import { Select } from '@pickatale/ui-kit';
import { Collection } from '@/api/types';

interface ManageClassSelectProps {
  className?: string;
  classes: Array<Collection> | undefined;
  currentClass?: Collection;
  onChange: (klass?: Collection) => void;
}

export const ManageClassSelect = ({
  className,
  classes,
  currentClass,
  onChange,
}: ManageClassSelectProps) =>
  classes && (
    <div className={clsx('max-w-64', className)}>
      <Select
        label="Select current class"
        hideLabel
        isRounded
        displayRadioDots={false}
        name="currentClass"
        variant="tonal"
        selectedValue={currentClass && currentClass.value}
        onValueChange={(newValue) =>
          onChange(classes.find((klass) => newValue === klass.value))
        }
        options={classes.map((klass) => ({
          label: klass.label,
          value: klass.value,
        }))}
        renderLabel={() => (
          <>
            Class <strong>{currentClass?.label}</strong>
          </>
        )}
      />
    </div>
  );
